import { IClassname } from '@/lib/shared/model/classname';

export const Layouts = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.001 4V6M14.8581 11H18.001"
        stroke="currentColor"
        strokeWidth="1"
      />
      <path
        d="M4.00098 11H10.001M10.001 9V13"
        stroke="currentColor"
        strokeWidth="1"
      />
      <path
        d="M15.3087 18H17.5426C17.7958 18 18.001 17.7948 18.001 17.5417V4.45833C18.001 4.2052 17.7958 4 17.5426 4H4.45931C4.20618 4 4.00098 4.2052 4.00098 4.45833V17.5417C4.00098 17.7948 4.20618 18 4.45931 18H10.2946C10.403 18 10.5079 17.9616 10.5907 17.8916L13.9625 15.0385"
        stroke="currentColor"
        strokeWidth="1"
      />
    </svg>
  );
};
